/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { INurse } from 'app/shared/model/nurse.model';

export interface IPreOPTimeOut {
  id?: string;
  correctPatient?: boolean;
  correctSiteAndSide?: boolean;
  correctProcedure?: boolean;
  agreementOnProcedure?: boolean;
  correctPatientPosition?: boolean;
  correctImplantAvailable?: boolean;
  correctEquipmentAvailable?: boolean;
  siteMatkingVerified?: boolean;
  relevantInvestigationsDone?: boolean;
  relevantImagesDone?: boolean;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  anaesthesiologist?: IDoctor;
  surgeon?: IDoctor;
  scrubNurse?: INurse;
}

export const defaultValue: Readonly<IPreOPTimeOut> = {
  correctPatient: false,
  correctSiteAndSide: false,
  correctProcedure: false,
  agreementOnProcedure: false,
  correctPatientPosition: false,
  correctImplantAvailable: false,
  correctEquipmentAvailable: false,
  siteMatkingVerified: false,
  relevantInvestigationsDone: false,
  relevantImagesDone: false,
  active: false,
};
